// Import utilities
import { isEmpty } from '@automator/utilities';

/**
 * Pro label <uo-pro-tag>
 * This file creates the web component
 */

class ProTag extends HTMLElement {
	constructor() {
		super();

		// Use Shadow DOM
		const shadowRoot = this.attachShadow( {
			mode: 'open',
		} );
	}

	connectedCallback() {
		this.shadowRoot.innerHTML = `
			<style>

				:host {
					display: inline-block;
					line-height: 0;
				}
				
				div {
					background: var( --uap-color-green );

					font-size: var( --uap-font-size--body-xsmall );
					line-height: var( --uap-line-height--body-xsmall );
					font-weight: 700;
					color: #fff;

					display: inline-flex;

					border-radius: 150px;

					padding: 0 6px;
				}

				[data-color="secondary"] {
					background: var( --uap-color-gray-2 );
				}

			</style>

			<div data-color="${this.color}">
				${UncannyAutomatorBackend.i18n.proLabel.pro}
			</div>
		`;
	}

	get color() {
		// Check if the user defined the style
		let tagStyle = this.getAttribute( 'color' );
		tagStyle = ! isEmpty( tagStyle ) ? tagStyle : 'primary';

		return tagStyle;
	}
}

customElements.define( 'uo-pro-tag', ProTag );
